<template>
  <div>
    <agreement v-if="status === 1"/>
    <wallet v-if="status === 2 " :walletInfo="myWalletInfo"/>
    <disabled v-if="status === 3"/>
    <div class="loading_style" v-if="status === -1">
      <loading size="40px" vertical>加载中...</loading>
    </div>
  </div>
</template>

<script>
import Wallet from '@/views/wallet/Wallet'
import Agreement from '@/views/wallet/Agreement'
import Disabled from '@/views/wallet/Disabled'
import { queryWalletInfo } from '@/request/api.encryptor'
import { Toast, Loading } from 'vant'

export default {
  name: 'Index',
  components: {
    Disabled,
    Agreement,
    Wallet,
    Loading
  },
  data() {
    return {
      status: -1,
      myWalletInfo: {}
    }
  },
  beforeMount() {
  },
  mounted() {
    this.$nextTick(() => {
      this.getWalletInfo()
      this.bus.$on('agreement', this.agreement)
      this.bus.$on('changeWallet', this.changeWallet)
    })
  },
  methods: {
    changeWallet(status) {
      this.status = status
    },
    // 同意协议
    agreement() {
      this.status = -1
      this.getWalletInfo()
    },
    // 查询钱包信息
    getWalletInfo() {
      queryWalletInfo()
          .then(res => {
            const { code, info = {}, msg = '' } = res || {}
            if (code === 0) {
              this.myWalletInfo = info
              this.status = 2
            } else if (code === 450) {
              // 用户未开户
              this.status = 1
            } else if (code === 443) {
              // 请联系管理员
              this.status = 3
            } else {
              Toast.fail(msg)
              this.back(1000)
            }
          })
          .catch(msg => {
            Toast.fail(msg)
            this.back(1000)
          })
    },
    back(time = 0) {
      setTimeout(() => {
        this.$JD.goBack()
      }, time)
    }
  }
}
</script>

<style scoped lang="scss">
.loading_style {
  display: flex;
  width: 100%;
  height: 100vh;
  align-items: center;
  justify-content: center;
}

</style>
